import { gql } from '@apollo/client';

export const UPDATE_SURFACE_WEATHER_STATION = gql`
    mutation UpdateSurfaceWeatherStation($id: Guid!, $input: UpdateSurfaceWeatherStation!) {
        facility {
            process {
                updateSurfaceWeatherStation(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
